import type { FC, PropsWithChildren } from "react";
import React from "react";

import { ToastCommon } from "../helper/ToastCommon";

import type {
    PropsWithCustomVarsStyles,
    PropsWithTsId,
} from "../../../types/react";
import type { IToastCommonProps } from "../helper/ToastCommon";

import classes from "./Toast.styl";

const TOAST_TEST_ID = "toast-test-id";
const TOAST_DISPLAY_NAME = "Toast";

export type ToastProps = PropsWithCustomVarsStyles<
    Pick<
        IToastCommonProps,
        | "title"
        | "subtitle"
        | "direction"
        | "timer"
        | "fillHorizontal"
        | "timerDuration"
    >
> &
    Partial<PropsWithTsId>;

/**
 * Используется библиотека sonner.
 *
 * <a href="https://uikit.odkl.ru/?path=/docs/%D0%BA%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82%D1%8B-toast-%D0%B8%D1%81%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B5-%D0%BA%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82%D0%B0-toast--docs" target="_blank">Дока про использование компонента Toast</a>
 *
 * Компонент, который в виде всплывающего сообщения, отображает для пользователя информацию об изменениях в приложении и даёт возможность выполнить контекстное действие
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?node-id=2-88973&p=f&m=dev" target="_blank">Спека</a>
 * @constructor
 */

export const Toast: FC<PropsWithChildren<ToastProps>> = (props) => {
    const { "data-tsid": tsid } = props;
    return (
        <ToastCommon
            {...props}
            data-tsid={tsid || TOAST_TEST_ID}
            classes={classes}
            data-uikit={TOAST_DISPLAY_NAME}
        />
    );
};

Toast.displayName = "Toast";
export default Toast;
